export enum UpsellTitles {
    RoomUpgrade = 'Room Upgrade',
    RoomService = 'Room Service',
    Breakfast = 'Breakfast',
    LateCheckOut = 'Late Check-Out',
    Beverages = 'Beverages',
    FacilitiesBooking = 'Facilities Booking',
    Events = 'Events',
};

export enum ServiceTitles {
    MorningCall = 'Morning Call',
    Amenities = 'Amenities',
    Housekeeping = 'Housekeeping',
    RoomControl = 'Room Control',
    WhatsApp = 'WhatsApp',
    Call = 'Call',
};